export const environment = {
  production: false,
  //url: 'https://localhost:7266',
  url: 'https://backend.mvcmx-qa.com',
  // cognitoLoginUrl: 'https://om1gce1n9i.execute-api.us-east-1.amazonaws.com/auth/login',
  // cognitoMfaUrl: 'https://om1gce1n9i.execute-api.us-east-1.amazonaws.com/auth/mfa',
  // cognitoCodeVerification: 'https://om1gce1n9i.execute-api.us-east-1.amazonaws.com/auth/fromcognito'
  cognitoLoginUrl: 'https://t0pkti5dok.execute-api.us-east-1.amazonaws.com/auth/login',
  cognitoMfaUrl: 'https://t0pkti5dok.execute-api.us-east-1.amazonaws.com/auth/mfa',
  cognitoCodeVerification: 'https://t0pkti5dok.execute-api.us-east-1.amazonaws.com/auth/fromcognito'
};
